// extracted by mini-css-extract-plugin
export var container = "_r8-0";
export var dotAnimation = "_r8-2";
export var dotsLoading = "_r8-1";